import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import {
  UseOpportunityReturnType,
  useOpportunityInternalHook,
} from 'hooks/useOpportunity/useOpportunityInternal';
import { TOpportunity } from 'lib/models/opportunity';
import { StudentSocietyAttributes } from 'lib/models/student-society';
import { CompanyAttributes } from 'lib/models/company';

const initialContext: UseOpportunityReturnType = {
  opportunity: {} as TOpportunity,
  isOpportunityLoading: false,
  isFollowLoading: false,
  isExpired: false,
  isFollowing: false,
  isOpportunityUnappliable: false,
  isOpportunityAppliedOrUnappliable: false,
  isApplicationClosed: false,
  isEventEnded: false,
  aiFaqs: [],
  isApprovalRequired: false,
  isCapacityReached: false,
  isWaitlistEnabled: false,
  isAlmostSoldOut: false,
  queryUserAction: null,
  queryUserActionId: null,
  willJoinWaitlist: false,
  creatableForId: '',
  creatableForName: '',
  creatableForType: 'company',
  creatableForFollowingId: '',
  awaitingApproval: false,
  similarOpportunities: [],
  similarOpportunitiesLoading: false,
  isOpportunityPublicPage: false,
  isMatchesPage: false,
  matchSlug: '',
  isSearchPage: false,
  isPageFullyScrolled: false,
  handleShareURL: () => noop,
  updateUserAction: () => noop,
  creatableFor: {} as StudentSocietyAttributes | CompanyAttributes,
};

const OpportunityContext =
  createContext<UseOpportunityReturnType>(initialContext);

export const useOpportunity = () => useContext(OpportunityContext);

export const OpportunityProvider: React.FC<{
  opportunity: TOpportunity;
  isLoggedInData?: boolean;
  isOpportunityPublicPage?: boolean;
  isMatchesPage?: boolean;
  matchSlug?: string;
  isSearchPage?: boolean;
  isPageFullyScrolled?: boolean;
}> = ({
  children,
  opportunity,
  isLoggedInData = false,
  isOpportunityPublicPage = false,
  isMatchesPage = false,
  matchSlug,
  isSearchPage = false,
  isPageFullyScrolled = false,
}) => {
  const value = useOpportunityInternalHook({
    opportunity,
    isLoggedInData,
    isOpportunityPublicPage,
    isMatchesPage,
    matchSlug,
    isSearchPage,
    isPageFullyScrolled,
  });

  return (
    <OpportunityContext.Provider value={value}>
      {children}
    </OpportunityContext.Provider>
  );
};
